import React from "react";
import video from "../assets/clouds.mp4";
import "../style/style.scss";

const Clouds = () => {
  // const videoSource = "https://gfycat.com/ifr/AssuredWarpedGreatargus";

  return (
    <div className="clouds">
      <video
        autoPlay="autoplay"
        loop="loop"
        muted
        className="video"
        preload="auto"
        poster="https://thumbs.gfycat.com/AssuredWarpedGreatargus-mobile.jpg"
      >
        <source src={video} type="video/mp4" />
      </video>
    </div>
  );
};

export default Clouds;
